<template>
    <img
        v-if="isCustomIcon"
        v-on="$listeners"
        :style="style"
        :src="customIconUrlMapDict[value]"
    />
    <component
        v-else-if="isHeroIcon"
        v-on="$listeners"
        :is="heroIconComponentMapDict[value]"
        :size="heroIconSize"
    />
    <v-icon
        v-else
        v-on="$listeners"
        :style="style">
        {{ value }}
    </v-icon>
</template>

<script>
import {
    ClipboardListIcon,
    QrcodeIcon,
    PuzzleIcon,
    TicketIcon,
    WifiIcon,
    UsersIcon,
    SpeakerphoneIcon,
    StarIcon,
    TrashIcon,
    PrinterIcon,
    UserAddIcon,
    MapIcon,
    HomeIcon,
    InboxIcon
} from '@vue-hero-icons/outline'
import {
    LocationMarkerIcon
} from '@vue-hero-icons/solid'
export default {
    name: 'Icon',

    props: {
        value: {
            type: String,
            default: ''
        },

        size: {
            type: [String, Number],
            default: '24px'
        }
    },

    data () {
        return {
            customIconUrlMapDict: {
                custom_coin: '/assets/icons/coinIcon.png',
                custom_sort: '/assets/icons/sortInactive.png',
                custom_sortASC: '/assets/icons/sortASC.png',
                custom_sortDESC: '/assets/icons/sortDESC.png'
            },

            heroIconComponentMapDict: {
                hero_ClipboardList: ClipboardListIcon,
                hero_Ticket: TicketIcon,
                hero_Qrcode: QrcodeIcon,
                hero_Wifi: WifiIcon,
                hero_Puzzle: PuzzleIcon,
                hero_Users: UsersIcon,
                hero_Speakerphone: SpeakerphoneIcon,
                hero_Star: StarIcon,
                hero_Trash: TrashIcon,
                hero_Printer: PrinterIcon,
                hero_UserAdd: UserAddIcon,
                hero_LocationMarker: LocationMarkerIcon,
                hero_Map: MapIcon,
                hero_Inbox: InboxIcon,
                hero_Home: HomeIcon,
                '': null
            }
        }
    },

    computed: {
        isHeroIcon () {
            return this.value.startsWith(this.$constant.HERO_ICON_PREFIX)
        },

        isCustomIcon () {
            return this.value.startsWith(this.$constant.CUSTOM_ICON_PREFIX)
        },

        heroIconSize () {
            return typeof this.size === 'string'
                ? this.size.replaceAll('px', '')
                : `${this.size}`
        },

        style () {
            const sizeInPixelStr =
                typeof this.size !== 'string' ? `${this.size}px` : this.size
            return {
                fontSize: sizeInPixelStr,
                width: sizeInPixelStr,
                height: 'auto',
                objectFit: 'contain'
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
